
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#zoom-plus_svg__clip0_735_45771)"}},[_c('path',{attrs:{"d":"M9 6H7V4c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5v2H4c-.281 0-.5.25-.5.5 0 .281.219.5.5.5h2v2c0 .281.219.5.5.5.25 0 .5-.219.5-.5V7h2c.25 0 .5-.219.5-.5 0-.25-.25-.5-.5-.5zm6.844 9.156l-4.438-4.406A6.443 6.443 0 0013 6.5C13 2.937 10.062 0 6.5 0 2.906 0 0 2.938 0 6.5 0 10.094 2.906 13 6.5 13a6.395 6.395 0 004.219-1.563l4.406 4.438c.094.094.219.125.375.125a.47.47 0 00.344-.125.53.53 0 000-.719zM6.5 12A5.488 5.488 0 011 6.5C1 3.469 3.438 1 6.5 1 9.531 1 12 3.469 12 6.5 12 9.563 9.531 12 6.5 12z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"zoom-plus_svg__clip0_735_45771"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    